module.exports = {
    'Tab': 9,
    'LeftArrow': 37,
    'UpArrow': 38,
    'RightArrow': 39,    
    'DownArrow': 40,
    'MinQueryLength': 2,
    'Esc': 27,
    'Enter': 13
};